import React, { Children, isValidElement } from "react";

import Item from "./_components/Item";

/**
 * The ButtonGroup component will take all the Button component children and
 * help arrange them in a stacked or horizontal row.
 *
 * @param { string } style -> The className used to determine the styling of
 *                            the component.
 *
 * @param { React.ReactNode } children -> The child elements of the ButtonGroup.
 *                                        It is assumed that each of these are
 *                                        Button components.
 */
export default function ButtonGroup({ style, children }) {

  const elementChildren = (children) => {
    return Children.toArray(children).filter(
      (child) => isValidElement(child)
    )
  };

  const buttons = elementChildren(children).map((child, index) => (
    <Item key={index} button={child} />
  ));

  return (
    <div className={style} >
      {buttons}
    </div>
  )
}
